<template>
  <ul class="grid grid-gap-2 grid-cols-2 s:grid-cols-3 xs:grid-cols-5">
    <li
      v-for="cast in casts.splice(0, 5)"
      :key="cast.id"
      class="text-center text-gray-500 p-2 hidden xs:block"
    >
      <router-link
        :to="{
          path: '/celebs/',
          name: 'CelebDetails',
          params: {
            id: cast.id
          }
        }"
      >
        <img
          v-if="cast['profile_path']"
          :src="profileImageUrl(cast['profile_path'])"
          :alt="cast['name']"
          class="rounded w-full"
        />
        <img
          v-else
          src="@/assets/images/avatar-icon.png"
          :alt="cast['name']"
          class="rounded w-full"
        />
        <p class="text-xs">{{ cast["name"] }}</p>
      </router-link>
    </li>
    <li
      v-for="cast in casts.splice(0, 6)"
      :key="cast.id"
      class="text-center text-gray-500 p-2 block xs:hidden"
    >
      <router-link
        :to="{
          path: '/celebs/',
          name: 'CelebDetails',
          params: {
            id: cast.id
          }
        }"
      >
        <img
          v-if="cast['profile_path']"
          :src="profileImageUrl(cast['profile_path'])"
          :alt="cast['name']"
          class="rounded w-full"
        />
        <img
          v-else
          src="@/assets/images/avatar-icon.png"
          :alt="cast['name']"
          class="rounded w-full"
        />
        <p class="text-xs">{{ cast["name"] }}</p>
      </router-link>
    </li>
  </ul>
</template>

<script>
export default {
  name: "casts",
  props: {
    data: {
      type: Array,
      required: true
    }
  },
  computed: {
    casts() {
      return [...this.data];
    }
  }
};
</script>

<style></style>
